export default {
	auth: {
        access_token: null,
        token_type: null,
        expires_in: 0,
        error: '',
        token_hash: ''
    },
}